define("auth/components/campaign-details", ["exports", "@ember/component", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div class="tSU--card tSU--card--campaign">
    <div class="u--p__lr__lg">
      <p class="tSU--card__title">{{this.campaign.name}}</p>
      <p class="u--text--light">{{this.brand}}</p>
      {{#if this.campaign.brief}}
        <p class="tSU--card--campaign__desc">
          {{html-safe this.campaign.about}}
        </p>
      {{/if}}
    </div>
    <div class="tSU--card--campaign__image">
      <figure class="o--mediaContainer">
        <img
          alt={{t "authorization.sign_up_campaign_form.campaign_img_alt"}}
          class="o--media"
          src={{this.campaign.campaign_image_url}}
        />
      </figure>
    </div>
  </div>
  */
  {
    "id": "xdJrVRwd",
    "block": "[[[10,0],[14,0,\"tSU--card tSU--card--campaign\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"u--p__lr__lg\"],[12],[1,\"\\n    \"],[10,2],[14,0,\"tSU--card__title\"],[12],[1,[30,0,[\"campaign\",\"name\"]]],[13],[1,\"\\n    \"],[10,2],[14,0,\"u--text--light\"],[12],[1,[30,0,[\"brand\"]]],[13],[1,\"\\n\"],[41,[30,0,[\"campaign\",\"brief\"]],[[[1,\"      \"],[10,2],[14,0,\"tSU--card--campaign__desc\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[[30,0,[\"campaign\",\"about\"]]],null]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n  \"],[10,0],[14,0,\"tSU--card--campaign__image\"],[12],[1,\"\\n    \"],[10,\"figure\"],[14,0,\"o--mediaContainer\"],[12],[1,\"\\n      \"],[10,\"img\"],[15,\"alt\",[28,[37,2],[\"authorization.sign_up_campaign_form.campaign_img_alt\"],null]],[14,0,\"o--media\"],[15,\"src\",[30,0,[\"campaign\",\"campaign_image_url\"]]],[12],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[],false,[\"if\",\"html-safe\",\"t\"]]",
    "moduleName": "auth/components/campaign-details.hbs",
    "isStrictMode": false
  });
  class CampaignDetailsComponent extends _component2.default {
    get campaign() {
      return this.args.campaign;
    }
    get brand() {
      return `By ${this.campaign.brand_name}`;
    }
  }
  _exports.default = CampaignDetailsComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, CampaignDetailsComponent);
});